import stls from '@f_qwep/styles/component/price/Price.module.sass';

export function CellType({ info }: any) {
    return <p className={stls.cellType}>{info.row.original.securityType}</p>;
}
